module.exports = __webpack_public_path__ + "img/uparrow.0c9456ee.svg";